"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _components = require("components");

var _reduxForm = require("redux-form");

var _reactRedux = require("react-redux");

var _auth = require("redux/modules/auth");

var authActions = _interopRequireWildcard(_auth);

var _loginFormValidation = require("utils/loginFormValidation");

var _index = require("../ChangePasswordPopup/index.jsx");

var _index2 = _interopRequireDefault(_index);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChangePasswordPopup = (_dec = (0, _reduxForm.reduxForm)({
  form: "changePassword",
  fields: ["password", "repeatPassword", "oldPassword"],
  validate: _loginFormValidation.validateChangePassword
}), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.user
  };
}, (0, _extends3.default)({}, authActions)), _dec(_class = _dec2(_class = function (_React$Component) {
  (0, _inherits3.default)(ChangePasswordPopup, _React$Component);

  function ChangePasswordPopup(props) {
    (0, _classCallCheck3.default)(this, ChangePasswordPopup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ChangePasswordPopup.__proto__ || (0, _getPrototypeOf2.default)(ChangePasswordPopup)).call(this, props));

    _this.state = {
      message: null,
      error: null
    };

    _this.onChangePasswordClick = _this.onChangePasswordClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ChangePasswordPopup, [{
    key: "onChangePasswordClick",
    value: function onChangePasswordClick(values, dispatch) {
      var _this2 = this;

      var password = values.password,
          repeatPassword = values.repeatPassword,
          oldPassword = values.oldPassword;
      var _props$user = this.props.user,
          etag = _props$user.etag,
          email = _props$user.email;

      this.setState({
        message: null,
        error: null
      });

      if (password !== repeatPassword) {
        return false;
      }

      return this.props.updatePassword(password, repeatPassword, oldPassword).then(function () {
        _this2.setState({
          message: "Successfully changed the password."
        });
      }, function (reason) {
        if (reason.code === "IncorrectPassword") {
          _this2.setState({
            error: "The old password looks incorrect. Please try again."
          });
        } else {
          _this2.setState({
            error: reason.message
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          _props$fields = _props.fields,
          passwordInputProps = _props$fields.password,
          repeatPasswordInputProps = _props$fields.repeatPassword,
          oldPasswordInputProps = _props$fields.oldPassword,
          submitting = _props.submitting,
          handleSubmit = _props.handleSubmit;


      return _react2.default.createElement(_index2.default, {
        icon: "/quixel_2080_logo.png",
        passwordInputProps: passwordInputProps,
        repeatPasswordInputProps: repeatPasswordInputProps,
        oldPasswordInputProps: oldPasswordInputProps,
        submitting: submitting,
        message: this.state.message,
        error: this.state.error,
        onSubmit: handleSubmit(this.onChangePasswordClick)
      });
    }
  }]);
  return ChangePasswordPopup;
}(_react2.default.Component)) || _class) || _class);
exports.default = ChangePasswordPopup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ChangePassword/ChangePasswordPopup.js
// module id = 2576
// module chunks = 0